<template>
  <div class="container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Promote Student</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Academic Year"
            outlined
            @change="getStd()"
            @click="putnull"
            persistent-hint
          />
        </v-col>
        <v-col sm="3" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="getDiv"
            @click="putnull"
            persistent-hint
          />
        </v-col>
        <v-col sm="3" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div"
            return-object
            :items="div_list"
            item-text="div_name"
            label="Division"
            outlined
            @click="putnull"
            persistent-hint
          />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && sel_std_data">
          <v-btn
            class="mt-6 button"
            @click="getStudents()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
      <span v-if="mainList != '' && mainList != null">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            show-select
            v-if="mainList.length > 0"
            :headers="headers"
            :items="mainList"
            :search="search"
            class="elevation-1"
            v-model="selectedTasks"
            :single-select="singleSelect"
            item-key="ldiv"
            >
            <!-- <template v-slot:[`item.ispromoted`]="{ item }">
              <span v-if="item.ispromoted">
                <v-icon
                  class="mr-2 v-icon-size"
                  color="success"
                  title="Promoted"
                  >mdi-check-circle-outline</v-icon
                >
              </span>
              <span v-else>
                <v-icon
                  class="mr-2 v-icon-size"
                  color="error"
                  title="Not Promoted"
                  >mdi-close-circle-outline</v-icon
                >
              </span>
            </template> -->
          </v-data-table>
        </v-card>
        <v-card-actions class="justify-center">
          <v-btn
            color="primary darken-1"
            dark
            @click="promote_students"
            :loading="fetch_loader"
            >Promote Students</v-btn
          >
        </v-card-actions>
      </span>
    </v-card>
    <!-- <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Student List
            <v-spacer></v-spacer>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  v-model="atten_date"
                  @blur="date = parseDate(atten_date)"
                  v-on="on"
                  hint="Date of Attendance"
                  prepend-icon="event"
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu1 = false"
                :max="nowDate"
              ></v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveattendance()"
              >Save Attendance</v-btn
            >
            <span style="width: 30px"> </span>

            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-model="selectedTasks"
            :single-select="singleSelect"
            :headers="headers"
            :items="studentinfo"
            item-key="ldiv"
            :search="search"
            class="elevation-1"
            show-select
          >
            <template v-slot:[`item.action`]="{ item }">
              <div>
                <v-avatar size="25" class="edit-avatar">
                  <v-icon
                    class="mr-2 edit-v-icon"
                    @click="editItem(item)"
                    title="edit"
                    >edit</v-icon
                  >
                </v-avatar>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row> -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data: () => ({
    headers: [
      { text: "Roll Number", value: "rollnumber", align: "center" },
      { text: "Student Name", value: "studentname", align: "center" },
      { text: "Registration Number", value: "grnumber", align: "center" },
      { text: "Is Promoted", value: "ispromoted", align: "center" },
    ],
    singleSelect: false,
    fetch_loader: false,
    mainList: [],
    ay_std_div_list: null,
    std_div_list: null,
    selectedTasks: [],
    overlay: false,
    div_list: null,
    sel_std_data: null,
    divoff: "",
    studentinfo: "",
    ay: "",
    standard: "",
    division: "",
    dayno: "",
    search: "",
    atten_date: "",
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    editedIndex: {
      rollnumber: "",
      studentname: "",
      grnumber: "",
      totalpresent: "",
      ldiv: "",
    },
    nowDate: new Date().toISOString().slice(0, 10),
  }),

  mounted() {
    this.onload();
  },
  methods: {
    promote_students() {
      this.fetch_loader = true;
      this.overlay = true;
      const data = {
        selectedstudents: [],
      };
      console.log("insselectedTaskside promote_students");
      console.log(this.selectedTasks);
      var index = 0;
      this.selectedTasks.forEach(function (item) {
        // your logic
        //alert("presentstudents"+item.studentname)
        data.selectedstudents[index] = item.ldiv;
        index++;
      });

      axios
        .post("/Admission/promote_students", data)
        .then((res) => {
          console.log(res.data);
          if (res.data.code == "SUCCESS") {
            //alert("Attendance Marked Successfully")
            this.showSnackbar("#4caf50", "Students promoted successfully..."); //res.data.status;
            this.getStudents();
            this.fetch_loader = false;
            this.overlay=false;
            //this.load=true
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
            this.overlay=false;
          }
        })
        .catch((error) => {
          this.fetch_loader = false;
          this.overlay=false;
          window.console.log(error);
        });
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      // this.std_div_list = ["All"];
      // this.sel_std_data ="All";
      this.std_div_list = this.sel_ay_data.std_list;
      // this.std_div_list.unshift("All");
    },
    getDiv() {
      // console.log("inside getDiv"+this.sel_std_data)
      // if(this.sel_std_data =='All'){
      //   this.div_list = null;
      // } else{
      //   this.div_list = ["All"];
      //   this.div = "All";
      //   this.div_list = this.sel_std_data.div_list;
      //   this.div_list.unshift("All");
      //   this.div = this.div_list[0];
      //   if (this.div_list.length == 0) {
      //     alert("No division found!!!");
      //     this.div_list = null;
      //   }
      // }
      this.div_list = this.sel_std_data.div_list;
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    putnull() {
      this.mainList = [];
    },
    onload() {
      this.overlay = true;
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    // getDivisionStudent() {
    //   if (this.$store.getters.divoff_id == null) {
    //     // alert("divoff");
    //     this.$router.push({ name: "student-attendance" });
    //   }
    //   //this.divoff=this.$store.getters.divoff_id
    //   const data = {
    //     divoff: this.$store.getters.divoff_id,
    //   };

    //   axios
    //     .post("/Academics/getDivisionStudent", data)
    //     .then((res) => {
    //       if (res.data.msg == "200") {
    //         this.studentinfo = res.data.studentinfo;
    //         this.ay = res.data.ay;
    //         this.standard = res.data.standard;
    //         this.division = res.data.division;
    //         this.dayno = res.data.dayno;

    //         //this.load=true
    //       } else {
    //       }
    //     })
    //     .catch((error) => {
    //       window.console.log(error);
    //     });
    // },
    getStudents() {
      this.overlay = true;
      this.fetch_loader = true;
      // console.log("this.div.div_id: "+this.div)
      // console.log("this.sel_std_data: "+this.sel_std_data)
      // let formData
      // let ay;
      // let div;
      // let standard;
      // if(this.sel_std_data == "All"){
      //   // console.log("inside this.div == null")
      //   //"All" option in standard is selected
      //   ay;
      //   standard = this.sel_std_data;

      //   if (this.sel_ay_data.ay_id) {
      //     ay = this.sel_ay_data.ay_id;
      //   } else if (this.sel_ay_data.id) {
      //     ay = this.sel_ay_data.id;
      //   }

      //   formData = {
      //     ay: ay,
      //     standard: standard,
      //   };
      //   // console.log(": "+formData.ay)
      //   // console.log(": "+formData.standard)
      // }
      // else{
      //   //  console.log("inside particular standard and division is selected ")
      //   //particular standard and division is selected
      // ay;
      // div = this.div.div_id;
      // standard = this.sel_std_data.std_id;

      // if (this.sel_ay_data.ay_id) {
      //   ay = this.sel_ay_data.ay_id;
      // } else if (this.sel_ay_data.id) {
      //   ay = this.sel_ay_data.id;
      // }
      // if (this.div.div_id) {
      //   div = this.div.div_id;
      // } else {
      //   div = this.div;
      // }

      //   formData = {
      //     ay: ay,
      //     division: div,
      //     standard: standard,
      //   };
      //   // console.log(": "+formData.ay)
      //   // console.log(": "+formData.standard)
      //   // console.log(": "+formData.division)
      // }
      // console.log(" inside getStudents this.div");
      // console.log(this.div);
      const data = {
        divoff: this.div.div_off_id,
      };
      axios
        .post("/Admission/get_students_for_promote", data)
        .then((res) => {
          if (res.data.studentinfo.length != 0) {
            this.mainList = res.data.studentinfo;
            this.fetch_loader = false;
            this.overlay=false;
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
            this.overlay=false;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
          this.overlay=false;
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay=false;
        });
    },
    editItem(item) {
      this.editedIndex = this.studentinfo.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("setldiv_id", this.editedItem.ldiv);
      // this.$router.push({ name: "view-studentattendance" });

      //this.dialog = true;
    },

    // saveattendance() {
    //   //alert("presentstudents"+this.selectedTasks[0].ldiv)
    //   if (this.atten_date == "" || this.atten_date == null) {
    //     this.showSnackbar("#b71c1c", "Please Select Attendance Date");
    //     return;
    //   }
    //   const data = {
    //     presentstudent: [],
    //     date: this.atten_date,
    //     allstudents: [],
    //     divoff: this.$store.getters.divoff_id,
    //     dayno: this.dayno,
    //   };
    //   var index = 0;
    //   this.selectedTasks.forEach(function (item) {
    //     // your logic
    //     //alert("presentstudents"+item.studentname)
    //     data.presentstudent[index] = item.ldiv;
    //     index++;
    //   });
    //   index = 0;
    //   this.studentinfo.forEach(function (item) {
    //     // your logic
    //     //alert("presentstudents"+item.studentname)
    //     data.allstudents[index] = item.ldiv;
    //     index++;
    //   });

    //   axios
    //     .post("/Academics/markAttendance", data)
    //     .then((res) => {
    //       if (res.data.msg == "200") {
    //         this.studentinfo = res.data.studentinfo;
    //         //alert("Attendance Marked Successfully")
    //         this.showSnackbar("#4caf50", "Attendance Marked Successfully..."); //res.data.status;
    //         this.dayno = res.data.dayno;

    //         //this.load=true
    //       } else {
    //       }
    //     })
    //     .catch((error) => {
    //       window.console.log(error);
    //     });
    // },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  // watch: {
  //   date(val) {
  //     this.atten_date = this.formatDate(this.date);
  //   },
  // },
};
</script>
